import { render, staticRenderFns } from "./hotSvg.vue?vue&type=template&id=7f9bcc7d"
import script from "./hotSvg.vue?vue&type=script&lang=ts"
export * from "./hotSvg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports